import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SimpleResponse } from '../models/genericResponse.model';
import { MenuResponse } from '../models/menu.model';
import { delayedRetryHttp } from './shared/delayedRetry';
import { UtilityService } from './shared/utility.service';

@Injectable()
export class MenuService {
  private baseUrl: string;
  private api: string = "api/Menu";
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
  }

    async getMenu(encryptedUser: string, userId: number, isRoleSetup: boolean = false, clpCompanyID: number = -1): Promise<MenuResponse | void> {
    const a = await this.httpClient
      .get<MenuResponse>(`${this.baseUrl}/Menu_Get/${userId}/${isRoleSetup}?CLPCompanyID=${clpCompanyID}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "userId - " + userId + "isRoleSetup - " + isRoleSetup, encryptedUser, "MenuService", "getMenu"); });
    return a;
  }

  async getFeaturePermissions(encryptedUser: string, permissionId: number): Promise<SimpleResponse | void> {
    const a = await this.httpClient
      .get<SimpleResponse>(`${this.baseUrl}/GetFeaturePermissions/${permissionId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "permissionId - " + permissionId, encryptedUser, "MenuService", "getFeaturePermissions"); });
    return a;
  }
}
